import { createGetPropGetter } from '@/store/utils';

export default {
  retryCounter: createGetPropGetter('retryCounter', {}),
  topLevelDomains: createGetPropGetter('topLevelDomains', []),
  topLevelDomainsAssets: createGetPropGetter('topLevelDomainsAssets', []),
  topLevelDomainsOptions: createGetPropGetter('topLevelDomainsOptions', []),
  successOperationMessage: createGetPropGetter('successOperationMessage', ''),
  downloadReportDisabled: createGetPropGetter('downloadReportDisabled', false),
  topLevelDomainListOptions: createGetPropGetter('topLevelDomainListOptions', {}),
  infrastructureListOptions: createGetPropGetter('infrastructureListOptions', {}),
  leaksListOptions: createGetPropGetter('leaksListOptions', {}),
  leaksListSort(state, { leaksListOptions = {} }) {
    return leaksListOptions.sort || {};
  },
  technologiesListOptions: createGetPropGetter('technologiesListOptions', {}),
  technologiesListSort(state, { technologiesListOptions = {} }) {
    return technologiesListOptions.sort || {};
  },
  topLevelDomainListSort(state, { topLevelDomainListOptions = {} }) {
    return topLevelDomainListOptions.sort || {};
  },
  infrastructureItems: createGetPropGetter('infrastructureItems', []),
  portOptions: createGetPropGetter('portOptions', []),
  wafOptions: createGetPropGetter('wafOptions', []),
  servicesOptions: createGetPropGetter('servicesOptions', []),
  locationOptions: createGetPropGetter('locationOptions', []),
  coordinatesOptions: createGetPropGetter('coordinatesOptions', []),
  infrastructureTagsSuggestions: createGetPropGetter('infrastructureTagsSuggestions', []),
  topLevelDomainTagsSuggestions: createGetPropGetter('topLevelDomainTagsSuggestions', []),
  leaksItems: createGetPropGetter('leaksItems', []),
  tldsWithNoLeaksScan: createGetPropGetter('tldsWithNoLeaksScan', []),
  tldsWithLeaksScan: createGetPropGetter('tldsWithLeaksScan', []),
  tldsWithNoEmployeesScan: createGetPropGetter('tldsWithNoEmployeesScan', []),
  tldsWithEmployeesScan: createGetPropGetter('tldsWithEmployeesScan', []),
  leaksSourceOptions: createGetPropGetter('leaksSourceOptions', []),
  leaksTypeOptions: createGetPropGetter('leaksTypeOptions', []),
  employeesListOptions: createGetPropGetter('employeesListOptions', {}),
  employeesListSort(state, { employeesListOptions = {} }) {
    return employeesListOptions.sort || {};
  },
  employeesItems: createGetPropGetter('employeesItems', []),
  technologiesItems: createGetPropGetter('technologiesItems', []),
  passwordSprayStatsUpdated: createGetPropGetter('passwordSprayStatsUpdated', false),
  cloudInstancesListOptions: createGetPropGetter('cloudInstancesListOptions', {}),
  cloudInstancesListSort(state, { cloudInstancesListOptions = {} }) {
    return cloudInstancesListOptions.sort || {};
  },
  cloudInstancesItems: createGetPropGetter('cloudInstancesItems', []),
  cloudInstancesFullItems: createGetPropGetter('cloudBucketsFullItems', []),
  cloudBucketsListOptions: createGetPropGetter('cloudBucketsListOptions', {}),
  cloudBucketsListSort(state, { cloudBucketsListOptions = {} }) {
    return cloudBucketsListOptions.sort || {};
  },
  cloudBucketsItems: createGetPropGetter('cloudBucketsItems', []),
  cloudBucketsFullItems: createGetPropGetter('cloudBucketsFullItems', []),
  loadingPasswordSpray: createGetPropGetter('loadingPasswordSpray', false),
  notValidatedDomains: createGetPropGetter('notValidatedDomains', []),
  domainsWithoutLicense: createGetPropGetter('domainsWithoutLicense', []),
  topLevelDomainsLoading: createGetPropGetter('topLevelDomainsLoading', false),
  infrastructureLoading: createGetPropGetter('infrastructureLoading', false),
  employeesLoading: createGetPropGetter('employeesLoading', false),
  technologiesLoading: createGetPropGetter('technologiesLoading', false),
  leaksLoading: createGetPropGetter('leaksLoading', false),
  cloudInstancesLoading: createGetPropGetter('cloudInstancesLoading', false),
  cloudBucketsLoading: createGetPropGetter('cloudBucketsLoading', false),
  cloudServicesLoading: createGetPropGetter('cloudServicesLoading', false),
  cloudAccountsLoading: createGetPropGetter('cloudAccountsLoading', false),
  infrastructureRefId: createGetPropGetter('infrastructureRefId', ''),
  infrastructureProgress: createGetPropGetter('infrastructureProgress', 0),
  employeesRefId: createGetPropGetter('employeesRefId', ''),
  employeesProgress: createGetPropGetter('employeesProgress', 0),
  technologiesRefId: createGetPropGetter('technologiesRefId', ''),
  technologiesProgress: createGetPropGetter('technologiesProgress', 0),
  cloudInstancesRefId: createGetPropGetter('cloudInstancesRefId', ''),
  cloudInstancesProgress: createGetPropGetter('cloudInstancesProgress', 0),
  cloudBucketsRefId: createGetPropGetter('cloudBucketsRefId', ''),
  cloudBucketsProgress: createGetPropGetter('cloudBucketsProgress', 0),
  cloudServicesRefId: createGetPropGetter('cloudServicesRefId', ''),
  cloudServicesProgress: createGetPropGetter('cloudServicesProgress', 0),
  topLevelDomainsRefId: createGetPropGetter('topLevelDomainsRefId', ''),
  topLevelDomainsProgress: createGetPropGetter('topLevelDomainsProgress', 0),
  infrastructureRunningInterval: createGetPropGetter('infrastructureRunningInterval', false),
  tldRunningInterval: createGetPropGetter('tldRunningInterval', false),
  employeesRunningInterval: createGetPropGetter('employeesRunningInterval', false),
  technologiesRunningInterval: createGetPropGetter('technologiesRunningInterval', false),
  cloudInstancesRunningInterval: createGetPropGetter('cloudInstancesRunningInterval', false),
  cloudBucketsRunningInterval: createGetPropGetter('cloudBucketsRunningInterval', false),
  cloudServicesRunningInterval: createGetPropGetter('cloudServicesRunningInterval', false),
  leaksRefId: createGetPropGetter('leaksRefId', ''),
  leaksProgress: createGetPropGetter('leaksProgress', 0),
  leaksRunningInterval: createGetPropGetter('leaksRunningInterval', false),
  infostealersListOptions: createGetPropGetter('infostealersListOptions', {}),
  infostealersItems: createGetPropGetter('infostealersItems', []),
  infostealersLoading: createGetPropGetter('infostealersLoading', false),
  infostealersFilters: createGetPropGetter('infostealersFilters', {}),
  infostealersRefId: createGetPropGetter('infostealersRefId', ''),
  infostealersProgress: createGetPropGetter('infostealersProgress', 0),
  infostealersRunningInterval: createGetPropGetter('infostealersRunningInterval', false),
  infostealersProgressData: createGetPropGetter('infostealersProgressData', { running_jobs: [], total_running: 0 }),
  infostealersPollingInterval: createGetPropGetter('infostealersPollingInterval', null),
  lastInfostealersProgressCall: createGetPropGetter('lastInfostealersProgressCall', null),
};
